import {createSlice} from '@reduxjs/toolkit'

const loginSlice = createSlice({
    name: 'project',
    initialState: {
        isAdmin: false,
        isLoggedIn: false,
        isEditing: {value:false, id:null, type:''},
        shareId:null,
        shareImages: null,
        user: null,
        popups: {
            signIn: false,
            signUp: false,
        },
    },
    reducers: {
        setPopups: (state, action) => {
            let {property, value } = action.payload;
            state.popups[property] = value;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setIsAdmin: (state, action) => {
            state.isAdmin = action.payload;
        },
        setIsLoggedIn: (state, action) => {
            state.isLoggedIn = action.payload;
        },
        setIsEditing: (state, action) => {
            state.isEditing = action.payload;
        },
        setSharedId: (state, action) => {
            state.shareId = action.payload;
        },
        setShareImages: (state, action) => {
            state.shareImages = action.payload;
        },
        setSignUpOnEditor: (state, action) => {
            state.signUpOnEditor = action.payload;
        },
    }
});

export const {setUser, setIsLoggedIn, setIsEditing, setIsAdmin, setShareImages, setSharedId} = loginSlice.actions;
export default loginSlice.reducer;
